import React, { forwardRef } from 'react';
import { Menu } from '@headlessui/react';

import { ComponentPropsWithRef } from '../../types/utils';

export const DropdownItems = forwardRef<
  HTMLDivElement,
  ComponentPropsWithRef<'div'>
>(function DropdownItems({ children, ...rest }, ref) {
  return (
    <Menu.Items
      ref={ref}
      className="bg-white py-2 rounded-lg text-sm shadow-md focus:outline-none"
      {...rest}
    >
      {children}
    </Menu.Items>
  );
});
